import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const ingProjectsSettingsApi = createApi({
  reducerPath: 'ingProjectsSettingsApi',
  baseQuery: axiosFetchBase,
  tagTypes: ['IngProjectsSettings', 'AssignmentStatus'],
  endpoints: (builder) => ({
    getIngProjectsSettings: builder.query({
      query: () => ({
        url: urls.ingProjectsSettings,
      }),
      providesTags: ['IngProjectsSettings'],
    }),

    saveIngProjectsSettings: builder.mutation({
      query(data) {
        return {
          url: urls.ingProjectsSettings,
          method: 'POST',
          data: data,
        };
      },
      invalidatesTags: ['IngProjectsSettings'],
    }),

    prepareNewYear: builder.mutation({
      query: () => ({
        url: urls.ingProjectsSettingsPrepareNewYear,
        method: 'POST',
      }),
      invalidatesTags: ['IngProjectsSettings'],
    }),

    importAcceptedStudents: builder.mutation({
      query(req) {
        const packedData = new FormData();
        packedData.append('file', req.file);
        return {
          url: urls.ingProjectsAcceptedStudentsImport,
          method: 'POST',
          data: packedData,
          suppress422Toast: true,
        };
      },
      invalidatesTags: ['AssignmentStatus'],
    }),
  }),
});

export const {
  useGetIngProjectsSettingsQuery,
  useSaveIngProjectsSettingsMutation,
  usePrepareNewYearMutation,
  useImportAcceptedStudentsMutation,
} = ingProjectsSettingsApi;
